export interface IDocumentSignStatusResponse {
        igsCustomerNumber: string;
        responseCode: string;
        errorMessage: string;
    }

    export class DocumentSignStatusResponse {
        igsCustomerNumber: string;
        responseCode: string;
        errorMessage: string;
    }